import React, { Component } from 'react';
import { connect } from 'react-redux';
import config from '../../config/config.json';
import { getSingleDocument, postSubmissionEdit } from '../../actions/studentdashboard';
import { Link } from 'react-router-dom';
import TopNav from '../includes/TopNav.js';
import { getReceiptPriceForExtra, getPresentedEnglishType, getFormattedTime } from '../../util/displayUtils.js';
import moment from 'moment'

class DashboardDetails extends Component {
    constructor(props) {
        super(props)
        console.log("starting view of paper");
        this.state = {'docDetailsFetched': false}
    }
    componentDidMount(props) {
        console.log("checking props ", this.props);
        this.getSingleDocument(this.props.match.params.docID, function(resBody) {
            if(resBody.data && resBody.data.length > 0) {
                this.setState({'docDetailsFetched': true})
            }
        }.bind(this));
    }
    postSubmissionEdit(id) {
      var self = this
    }
    getSingleDocument(doc_ID, cb) {
        this.props.dispatch(getSingleDocument(doc_ID, function(resBody){
            if(cb) {
                cb(resBody);
            }
        }))
    }
    
    render() {
        if(this.state.docDetailsFetched){
          let extrasArr = JSON.parse(this.props.Dashboard.submission_details.extras);
          var extras = extrasArr.map((submission, i) => {
            return(
              <div>
                <div>{submission} - ${getReceiptPriceForExtra(this.props.Dashboard.submission_details, submission)}</div>
              </div>
            )
          });
          var fullPaid =  this.props.Dashboard.submission_details.receipt_total_amount + this.props.Dashboard.submission_details.receipt_tax;
          var postCoupon = this.props.Dashboard.submission_details.doc_cost - this.props.Dashboard.submission_details.receipt_coupon;
          var preTax = this.props.Dashboard.submission_details.receipt_total_amount;
        }
        return(
            <div>
              <TopNav />
              <section>
              <div className="dashboardpaperdetails">
                  <br/><br/>
                  <h2><b>{this.props.Dashboard.submission_details.doc_name}</b></h2>
                  <p><b>Due Date:</b><span className="details-data"> {getFormattedTime(this.props.Dashboard.submission_details.due_date)}</span></p>
                  <p><b>Upload Date:</b><span className="details-data"> {getFormattedTime(this.props.Dashboard.submission_details.upload_date)}</span></p>
                  <p><b>Word Count:</b><span className="details-data"> {this.props.Dashboard.submission_details.word_count}</span></p>
                  <p><b>Time Limit: </b><span className="details-data">{this.props.Dashboard.submission_details.time_limit}</span></p>
                  <p><b>Editor Level: </b><span className="details-data">{this.props.Dashboard.submission_details.editor_level}</span></p>
                  <p><b>Price: </b><span className="details-data">${this.props.Dashboard.submission_details.doc_cost}</span></p>
                  <p><b>Code Value: </b><span className="details-data">${this.props.Dashboard.submission_details.receipt_coupon}</span></p>
                  <p><b>Post-Code Price: </b><span className="details-data">${postCoupon}</span></p>
                  <p><b>Tax: </b><span className="details-data">${this.props.Dashboard.submission_details.receipt_tax}</span></p>
                  <p><b>Paid: </b><span className="details-data">${fullPaid}</span></p>
                  <p><b>Type of English: </b><span className="details-data">{getPresentedEnglishType(this.props.Dashboard.submission_details.english)}</span></p>
                  <p><b>Instructions:</b><span className="details-data"> {this.props.Dashboard.submission_details.instructions || 'none'}</span></p>
                  {(this.props.Dashboard.submission_details.instructions_file_name)?
                    <p><b>Instructions File:</b><a href={config.BASE + this.props.Dashboard.submission_details.instrunctions_file_path + '/' + this.props.Dashboard.submission_details.instructions_file_name} target="_blank">Download</a></p>
                    :
                    <p></p>
                    }
                  <p><b>Description:</b><span className="details-data"> {this.props.Dashboard.submission_details.description || 'none'}</span></p>
                  <p><b>Extras:</b></p>
                  {extras}
                  <br/>
                  <span>
                      <Link to="/studentdashboard/">Back</Link>
                  </span>
              </div>
              </section>
            </div>
        )
    }
}

export default connect( ({Dashboard}) => ({Dashboard}) ) (DashboardDetails)



// WEBPACK FOOTER //
// ./src/components/dashboards/StudentPaperDetails.js